import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useFetcher, useLoaderData, useLocation } from 'react-router-dom';
import PDFTesting from '../react-pdf/PDFTesting';
import { I_PDF_Document } from '../react-pdf/propTypes';
import logo from '../../../img/logo/logo_invoice_manager.svg';
import { capitalize } from '../../Helpers/stringFunctions';
import StatusBadge from '../../UI/StatusBadge';

import './PublicPdfPreview.scss';

function PublicPdfPreview() {
  const loaderData = useLoaderData() as I_PDF_Document;
  const fetcher = useFetcher();
  const { pathname } = useLocation();
  const type = pathname.substring(pathname.lastIndexOf('/') + 1);
  const companyLogo = loaderData?.data?.user?.company?.logo;
  const status = loaderData?.data?.status;

  if (!loaderData)
    throw new Error("Couldn't load PDF data. Please try again later.");

  const estimateActions = () => {
    if (status === 1)
      return (
        <div className="w-100 mt-4 pt-4 border-top border-subtle">
          <h6 className="mb-3">Estimate actions</h6>
          <div className="preview-pdf__estimate-actions">
            <fetcher.Form action="./accept" method="POST">
              <input
                name="estimateId"
                value={loaderData?.data?.id}
                hidden
                readOnly
              />
              <Button
                type="submit"
                variant="success"
                disabled={fetcher.state !== 'idle'}
              >
                Accept
              </Button>
            </fetcher.Form>
            <fetcher.Form action="./decline" method="POST">
              <input
                name="estimateId"
                value={loaderData?.data?.id}
                hidden
                readOnly
              />
              <Button
                type="submit"
                variant="danger"
                disabled={fetcher.state !== 'idle'}
              >
                Decline
              </Button>
            </fetcher.Form>
          </div>
        </div>
      );

    if (status === 2 || status === 3)
      return (
        <span className="d-flex gap-0 small fw-semibold w-100 mt-4 pt-4 border-top border-subtle preview-pdf__estimate-actions">
          Estimate status:
          <StatusBadge type="estimate" statusCode={status} />
        </span>
      );

    if (status === 5)
      return (
        <span className="d-flex gap-0 small text-danger fw-semibold w-100 mt-4 pt-4 border-top border-subtle preview-pdf__estimate-actions">
          This estimate expired, you need to request a new one.
        </span>
      );

    return null;
  };

  return (
    <main className="preview-pdf__container">
      <header className="preview-pdf__info">
        {companyLogo && (
          <img
            src={companyLogo}
            alt={`${loaderData.data.user.company.name} logo`}
          />
        )}

        <h1 className="fs-3 text-primary fw-medium mb-0">
          {loaderData.data.user.company.name}
        </h1>
        <h2 className="fs-5 text-secondary mb-2">
          Previewing {capitalize(type)}:{' '}
          <strong>{loaderData.data.number}</strong>
        </h2>

        <div id="download-pdf" />
        {type === 'estimate' && estimateActions()}
      </header>
      <div
        className="preview-pdf__pdf"
        style={{
          aspectRatio: '8.5 / 11',
          height: 'auto',
          width: 'min(95vw, 692px)',
        }}
      >
        <PDFTesting
          data={loaderData.data}
          portalId="download-pdf"
          publicRoute
          overrideColors={loaderData.colors}
          overrideLayout={loaderData.layoutNumber}
        />

        <footer className="preview-pdf__footer d-flex gap-3 align-items-center justify-content-center">
          <span className="text-muted small">Powered by:</span>
          <Link to="/">
            <img style={{ height: 40 }} src={logo} alt="leadsbox logo" />
          </Link>
        </footer>
      </div>
    </main>
  );
}

export default PublicPdfPreview;
